import { schema as schemas } from 'normalizr'

import { CallApi } from '@signavio/kraken'

export const collection = 'caseInfo'

export const schema = new schemas.Array(
  new schemas.Entity(collection, undefined, {
    idAttribute: 'editorWorkflowId',
  })
)

export const fetch = (callApi: CallApi, apiBase: string) => () =>
  callApi(`${apiBase}/info/cases`, schema)
